import React, {useCallback, useState} from "react";
import {Grid} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Application} from "../Application";
import {ContentPageTableHeader} from "../../../shared/components/tables/ContentPageTableHeader";
import {StandardRole} from "../../users/Role";
import {FormDialog} from "../../../shared/components/dialogs/FormDialog";
import {ApplicationUserGroup, defaultApplicationUserGroup} from "./ApplicationUserGroup";
import {ApplicationUserGroupForm} from "./ApplicationUserGroupForm";
import {useAxios} from "../../../shared/technical/rest/AxiosProvider";
import {getAllApplicationUserGroups} from "./ApplicationUserGroupApi";
import {useQuery} from "react-query";
import {ApplicationUserGroupCard} from "./ApplicationUserGroupCard";
import {isEditableForRoles} from "../../../shared/technical/security/WithRestrictedEdit";
import {useAccount} from "../../users/AccountProvider";
import {ApplicationSubPageContentContainer} from "../ApplicationSubPageContentContainer";

export function ApplicationUserGroupsSubPage(props: {
  application: Application,
}) {
  const {application} = props;
  const {t} = useTranslation();
  const axios = useAxios();
  const account = useAccount();
  const [showFormDialog, setShowFormDialog] = useState(false);
  const [actualEntity, setActualEntity] = useState<ApplicationUserGroup>(defaultApplicationUserGroup(application, t))

  const {data} = useQuery('applicationUserGroups', () => getAllApplicationUserGroups(axios, application.id!!), {});

  function handleCloseDialog(event?: {}, reason?: 'backdropClick' | 'escapeKeyDown') {
    if (reason === 'backdropClick') {
      console.info('backdrop click');
      return;
    }
    setShowFormDialog(false);
  }

  const handleAddButtonClick = useCallback(() => {
    setActualEntity(defaultApplicationUserGroup(application, t));
    setShowFormDialog(true);
  }, [application, t]);

  const handleSelectUserGroup = useCallback((userGroup: ApplicationUserGroup) => {
    setActualEntity(userGroup);
    setShowFormDialog(true);
  }, [setShowFormDialog, setActualEntity]);

  return (
    <ApplicationSubPageContentContainer>
      <ContentPageTableHeader onClick={handleAddButtonClick}
                              title={t('ApplicationUserGroups.titleLong')}
                              titleButton={t('ApplicationUserGroups.buttonCreate')}
                              isEditable={isEditableForRoles(account, [StandardRole.ADMIN, StandardRole.APPLICATION_ADMIN])}/>
      <Grid container={true} sx={{marginTop: 1}} spacing={2}>
        {data?.map((userGroup) =>
          <Grid key={userGroup.id} item={true} xs={12} sm={6} lg={4} xl={4}>
            <ApplicationUserGroupCard userGroup={userGroup} handleSelectUserGroup={handleSelectUserGroup}/>
          </Grid>
        )}
      </Grid>
      <FormDialog open={showFormDialog} handleClose={handleCloseDialog}>
        <ApplicationUserGroupForm application={application} userGroup={actualEntity} handleClose={handleCloseDialog}/>
      </FormDialog>
    </ApplicationSubPageContentContainer>
  )
}
